<template>
  <div>
    <div class="homePage">
      <div class="fiex" :style="{ top: menuTop + 'px' }">
        <Navigation :active="6"></Navigation>
      </div>
      <div class="right">
        <!-- 个人信息 -->
        <div class="my-info">
          <div class="title">{{ $t("module.account.title1") }}</div>
          <div class="info-box">
            <div class="head-box">
              <img
                class="head"
                v-if="$store.state.userInfo.avatarUrl"
                :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
              />
              <img class="head" v-else src="@/assets/image/module/head.png" />

              <div class="picture-box" @click="dialogVisible = true">
                <i class="el-icon-camera"></i>
              </div>
            </div>
            <div class="name-box">
              <div class="name">{{ $store.state.userInfo.userName }}</div>
              <div class="content">
                <div class="content-title">
                  {{ $t("module.account.title2") }}
                </div>
                <el-progress
                  :percentage="percentage"
                  :stroke-width="8"
                ></el-progress>
                <div class="tips">{{ $t("module.account.title3") }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 信息管理 -->
        <div class="tabs-box">
          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('module.account.title4')" name="1">
              <div class="info-boxs">
                <div class="line-box">
                  <div class="input-box">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title6") }}
                    </div>
                    <el-input
                      v-model="profileInfo.name"
                      :disabled="isName"
                      :placeholder="$t('module.account.title6')"
                    ></el-input>
                  </div>
                  <div class="input-box input-right">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title7") }}
                    </div>
                    <el-select
                      v-model="profileInfo.gender"
                      :placeholder="$t('module.account.title7')"
                      @change="changeGender"
                    >
                      <el-option
                        v-for="item in option1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div class="input-box">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title8") }}
                    </div>
                    <el-date-picker
                      :placeholder="$t('module.account.title8')"
                      v-model="profileInfo.birthday"
                      type="date"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </div>
                  <div class="input-box input-right">
                    <div class="title"><span>*</span>居住地</div>
                    <el-cascader
                      v-model="selectedOptions"
                      :props="cascaderProps"
                      @change="handleChange"
                      placeholder="请选择省/市/区"
                      clearable
                      :key="cascaderKey"
                    />
                  </div>
                  <div class="input-box">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title34") }}
                    </div>
                    <el-select
                      v-model="profileInfo.maritalStatus"
                      :placeholder="$t('module.account.title34')"
                    >
                      <el-option
                        v-for="item in MaritalStatus"
                        :key="item.ID"
                        :label="item.MarriageName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div class="input-box input-right">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title35") }}
                    </div>
                    <el-select
                      v-model="profileInfo.educationId"
                      :placeholder="$t('module.account.title35')"
                    >
                      <el-option
                        v-for="item in Educations"
                        :key="item.ID"
                        :label="item.EducationName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div class="input-box">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title36") }}
                    </div>
                    <el-select
                      v-model="profileInfo.occupationStatus"
                      :placeholder="$t('module.account.title36')"
                    >
                      <el-option
                        v-for="item in OccupationStatus"
                        :key="item.ID"
                        :label="item.WSName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div class="input-box input-right">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title37") }}
                    </div>
                    <el-select
                      v-model="profileInfo.personalIncome"
                      :placeholder="$t('module.account.title37')"
                    >
                      <el-option
                        v-for="item in Incomes"
                        :key="item.ID"
                        :label="item.IncomeName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div class="input-box">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title38") }}
                    </div>
                    <el-select
                      v-model="profileInfo.familyIncome"
                      :placeholder="$t('module.account.title38')"
                    >
                      <el-option
                        v-for="item in Incomes"
                        :key="item.ID"
                        :label="item.IncomeName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div class="input-box input-right">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title39") }}
                    </div>
                    <el-select
                      v-model="profileInfo.positionId"
                      :placeholder="$t('module.account.title39')"
                    >
                      <el-option
                        v-for="item in Positions"
                        :key="item.ID"
                        :label="item.PositionName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div class="input-box input-right">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title40") }}
                    </div>
                    <el-select
                      v-model="profileInfo.hasChildren"
                      :placeholder="$t('module.account.title40')"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.ID"
                        :label="item.label"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                  <div
                    class="input-box input-right"
                    v-if="profileInfo.hasChildren"
                  >
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title41") }}
                    </div>
                    <el-select
                      v-model="profileInfo.childGender"
                      :placeholder="$t('module.account.title41')"
                    >
                      <el-option
                        v-for="item in options1"
                        :key="item.ID"
                        :label="item.label"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>

                  <div
                    class="input-box input-right"
                    v-if="profileInfo.hasChildren"
                  >
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title42") }}
                    </div>

                    <el-date-picker
                      v-model="profileInfo.birthYearOfYoungChild"
                      type="year"
                      value-format="yyyy"
                      :placeholder="$t('module.account.title42')"
                    >
                    </el-date-picker>
                  </div>

                  <div class="input-box input-right">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title43") }}
                    </div>

                    <el-select
                      v-model="profileInfo.vehicleBrand"
                      :placeholder="$t('module.account.title43')"
                      @change="getVehicleBrandsModels"
                    >
                      <el-option
                        v-for="item in VehicleBrands"
                        :key="item.ID"
                        :label="item.BrandName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>

                  <div
                    class="input-box input-right"
                    v-if="
                      profileInfo.vehicleBrand && profileInfo.vehicleBrand !== 1
                    "
                  >
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title44") }}
                    </div>

                    <el-select
                      v-model="profileInfo.vehicleModel"
                      :placeholder="$t('module.account.title44')"
                    >
                      <el-option
                        v-for="item in VehicleBrandsModels"
                        :key="item.ID"
                        :label="item.ModelName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>

                  <div
                    class="input-box input-right"
                    v-if="
                      profileInfo.vehicleBrand && profileInfo.vehicleBrand !== 1
                    "
                  >
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title45") }}
                    </div>

                    <el-date-picker
                      v-model="profileInfo.vehiclePurchaseYear"
                      type="year"
                      value-format="yyyy"
                      :placeholder="$t('module.account.title45')"
                    >
                    </el-date-picker>
                  </div>

                  <div class="input-box">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title46") }}
                    </div>
                    <el-select
                      v-model="profileInfo.personalDisease"
                      :placeholder="$t('module.account.title46')"
                      multiple
                      @change="changePersonalDisease"
                    >
                      <el-option
                        v-for="item in Diseases1"
                        :key="item.ID"
                        :label="item.DiseaseName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>

                  <div class="input-box">
                    <div class="title">
                      <span>*</span>{{ $t("module.account.title47") }}
                    </div>
                    <el-select
                      v-model="profileInfo.familyDisease"
                      :placeholder="$t('module.account.title47')"
                      multiple
                      @change="changeFamilyDisease"
                    >
                      <el-option
                        v-for="item in Diseases"
                        :key="item.ID"
                        :label="item.DiseaseName"
                        :value="item.ID"
                      >
                      </el-option
                    ></el-select>
                  </div>
                </div>
              </div>

              <div class="info-boxs">
                <div class="line-box">
                  <div class="input-box">
                    <div class="title"></div>
                    <button
                      @click="setProfile"
                      :class="`${flagpc ? 'flagpc' : ''}`"
                    >
                      {{ $t("module.account.title17") }}
                    </button>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('module.account.title5')" name="2">
              <div class="account-boxs">
                <div class="account-box">
                  <div class="herder-box">
                    <div class="herder-left">
                      <div class="herder-title">
                        {{ $t("module.account.title21") }}
                      </div>
                      <div class="herder-content">{{ userInfo.mobile }}</div>
                    </div>
                    <div class="herder-right"></div>
                  </div>
                  <div class="tips">
                    1.
                    {{ $t("module.account.title52") }}<br />
                    2.
                    {{ $t("module.account.title53") }}
                  </div>
                </div>
                <div class="account-box">
                  <div class="herder-box">
                    <div class="herder-left">
                      <div class="herder-title">
                        {{ $t("module.account.title23") }}
                      </div>
                      <div class="herder-content">*****</div>
                    </div>
                    <div class="herder-right" @click="dialogVisible3 = true">
                      {{ $t("module.account.title20") }}
                    </div>
                  </div>
                  <div class="tips">{{ $t("module.account.title24") }}</div>
                </div>

                <div class="account-box">
                  <div class="herder-box">
                    <div class="herder-left">
                      <div class="herder-title">
                        {{ $t("module.account.title48") }}
                      </div>
                      <div class="herder-content">
                        <div v-if="alipay">
                          {{ alipayName }} {{ alipay | phoneFrom }}
                        </div>
                        <div v-else>{{ $t("module.account.title49") }}</div>
                      </div>
                    </div>
                    <div
                      class="herder-right"
                      v-if="!alipay"
                      @click="changeAlipay"
                    >
                      {{ $t("module.account.title50") }}
                    </div>
                  </div>
                  <div class="tips">
                    {{ $t("module.account.title51") }}
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="$t('module.account.title62')" name="3">
              <div class="account-boxs">
                <div class="account-box">
                  <div class="herder-box">
                    <div class="herder-left">
                      <div class="herder-title">
                        {{ $t("module.account.title25") }}
                      </div>
                      <div class="herder-content">
                        {{
                          userInfo.WeChatBound
                            ? $t("module.account.title30")
                            : $t("module.account.title49")
                        }}
                      </div>
                    </div>
                    <div class="herder-right">
                      <div v-if="!userInfo.WeChatBound">
                        {{
                          userInfo.WeChatBound
                            ? $t("module.account.title30")
                            : $t("module.account.title27")
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="tips">{{ $t("module.account.title28") }}</div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="moble-name">{{ $t("module.account.title31") }}</div>
        <div class="moble-info">
          <div class="title-box">
            <span></span>{{ $t("module.account.title54") }}
          </div>
          <div class="info-box">
            <div class="head-box">
              <img
                class="head"
                v-if="$store.state.userInfo.avatarUrl"
                :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
              />
              <img class="head" v-else src="@/assets/image/module/head.png" />

              <div class="picture-box" @click="dialogVisible = true">
                <i class="el-icon-camera"></i>
              </div>
            </div>

            <div class="name-box">
              <div class="name">{{ $store.state.userInfo.userName }}</div>
              <div class="content">
                <div class="content-title">
                  {{ $t("module.account.title2") }}
                </div>
                <el-progress :percentage="50" :stroke-width="8"></el-progress>
              </div>
              <div class="tips">{{ $t("module.account.title3") }}</div>
            </div>
          </div>
        </div>
        <div class="moble-info">
          <div class="title-box">
            <span></span>{{ $t("module.account.title4") }}
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title6") }}</div>
            <div class="input-box">
              <input
                v-model="profileInfo.name"
                :disabled="isName"
                :placeholder="$t('module.account.title68')"
              />
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title7") }}</div>
            <div class="input-box" @click="genderPicker = true">
              <div class="title" v-if="!this.profileInfo.gender">
                {{ $t("module.account.title33") }}
              </div>
              <div class="title2" v-else>
                {{ this.profileInfo.gender | leablDateFrom(option1) }}
              </div>

              <img src="@/assets/image/module/arrow-right.png" />
            </div>

            <van-popup v-model="genderPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="option1"
                @cancel="genderPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.gender = e.value;
                    this.genderPicker = false;
                    this.changeGender();
                  }
                "
                value-key="label"
                :default-index="genderIndex"
              />
            </van-popup>
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title8") }}</div>
            <div class="input-box" @click="birthdayPicker = true">
              <div class="title" v-if="!profileInfo.birthday">
                {{ $t("module.account.title33") }}
              </div>
              <div class="title2" v-else>{{ profileInfo.birthday }}</div>

              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="birthdayPicker" round position="bottom">
              <van-datetime-picker
                v-model="birthday"
                type="date"
                :title="$t('module.account.title67')"
                @confirm="birthdayConfirm"
                :min-date="minDate"
                :max-date="maxDate"
            /></van-popup>
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title9") }}</div>
            <div class="input-box" @click="provincePicker = true">
              <div class="title" v-if="!this.profileInfo.provinceId">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{ profileInfo.provinceId | nameFrom(province) }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="provincePicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="province"
                @cancel="provincePicker = false"
                @confirm="changeProvinceId2"
                value-key="name"
                :default-index="provinceIndex"
              />
            </van-popup>
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title10") }}</div>
            <div class="input-box" @click="citiesPicker = true">
              <div class="title" v-if="!profileInfo.cityId">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{ profileInfo.cityId | nameFrom(cities) }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="citiesPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="cities"
                @cancel="citiesPicker = false"
                @confirm="changeCityId2"
                value-key="name"
                :default-index="citiesIndex"
              />
            </van-popup>
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title11") }}</div>
            <div class="input-box" @click="districtsPicker = true">
              <div class="title" v-if="!profileInfo.districtId">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{ profileInfo.districtId | nameFrom(districts) }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="districtsPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="districts"
                @cancel="districtsPicker = false"
                @confirm="changeDistricts2"
                value-key="name"
                :default-index="districtsIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title34") }}</div>
            <div class="input-box" @click="maritalStatusPicker = true">
              <div class="title" v-if="!profileInfo.maritalStatus">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.maritalStatus
                    | labelName(MaritalStatus, "MarriageName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="maritalStatusPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="MaritalStatus"
                @cancel="maritalStatusPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.maritalStatus = e.ID;
                    this.maritalStatusPicker = false;
                  }
                "
                value-key="MarriageName"
                :default-index="MaritalIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title35") }}</div>
            <div class="input-box" @click="educationsPicker = true">
              <div class="title" v-if="!profileInfo.educationId">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.educationId
                    | labelName(Educations, "EducationName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="educationsPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="Educations"
                @cancel="educationsPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.educationId = e.ID;
                    this.educationsPicker = false;
                  }
                "
                value-key="EducationName"
                :default-index="EducationIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title36") }}</div>
            <div class="input-box" @click="OccupationStatusPicker = true">
              <div class="title" v-if="!profileInfo.occupationStatus">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.occupationStatus
                    | labelName(OccupationStatus, "WSName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="OccupationStatusPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="OccupationStatus"
                @cancel="OccupationStatusPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.occupationStatus = e.ID;
                    this.OccupationStatusPicker = false;
                  }
                "
                value-key="WSName"
                :default-index="occupationStatusIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title37") }}</div>
            <div class="input-box" @click="personalIncomePicker = true">
              <div class="title" v-if="!profileInfo.personalIncome">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.personalIncome | labelName(Incomes, "IncomeName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="personalIncomePicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="Incomes"
                @cancel="personalIncomePicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.personalIncome = e.ID;
                    this.personalIncomePicker = false;
                  }
                "
                value-key="IncomeName"
                :default-index="personalIncomeIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title38") }}</div>
            <div class="input-box" @click="familyIncomePicker = true">
              <div class="title" v-if="!profileInfo.familyIncome">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.familyIncome | labelName(Incomes, "IncomeName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="familyIncomePicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="Incomes"
                @cancel="familyIncomePicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.familyIncome = e.ID;
                    this.familyIncomePicker = false;
                  }
                "
                value-key="IncomeName"
                :default-index="familyIncomeIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title39") }}</div>
            <div class="input-box" @click="positionIdPicker = true">
              <div class="title" v-if="!profileInfo.positionId">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.positionId | labelName(Positions, "PositionName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="positionIdPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="Positions"
                @cancel="positionIdPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.positionId = e.ID;
                    this.positionIdPicker = false;
                  }
                "
                value-key="PositionName"
                :default-index="provinceIdIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title40") }}</div>
            <div class="input-box" @click="hasChildrenPicker = true">
              <div
                class="title"
                v-if="
                  !profileInfo.hasChildren && profileInfo.hasChildren !== false
                "
              >
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.hasChildren
                    ? $t("module.account.title65")
                    : $t("module.account.title66")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="hasChildrenPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="options"
                @cancel="hasChildrenPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.hasChildren = e.ID;
                    this.hasChildrenPicker = false;
                  }
                "
                value-key="label"
                :default-index="hasChildrenIndex"
              />
            </van-popup>
          </div>

          <div class="line-box" v-if="profileInfo.hasChildren">
            <div class="line-left">{{ $t("module.account.title41") }}</div>
            <div class="input-box" @click="childGenderPicker = true">
              <div class="title" v-if="!profileInfo.childGender">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.childGender === 1
                    ? $t("module.account.title63")
                    : $t("module.account.title64")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="childGenderPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="options1"
                @cancel="childGenderPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.childGender = e.ID;
                    this.childGenderPicker = false;
                  }
                "
                value-key="label"
                :default-index="childGenderIndex"
              />
            </van-popup>
          </div>

          <div class="line-box" v-if="profileInfo.hasChildren">
            <div class="line-left">{{ $t("module.account.title42") }}</div>
            <div class="input-box" @click="birthYearOfYoungChildPicker = true">
              <div class="title" v-if="!profileInfo.birthYearOfYoungChild">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{ profileInfo.birthYearOfYoungChild }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup
              v-model="birthYearOfYoungChildPicker"
              round
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="YearList"
                @cancel="birthYearOfYoungChildPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.birthYearOfYoungChild = e.year;
                    this.birthYearOfYoungChildPicker = false;
                  }
                "
                value-key="year"
                :default-index="birthYearOfYoungChildIndex"
              />
            </van-popup>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title43") }}</div>
            <div class="input-box" @click="vehicleBrandPicker = true">
              <div class="title" v-if="!profileInfo.vehicleBrand">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.vehicleBrand
                    | labelName(VehicleBrands, "BrandName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="vehicleBrandPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="VehicleBrands"
                @cancel="vehicleBrandPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.vehicleBrand = e.ID;
                    this.vehicleBrandPicker = false;
                    this.profileInfo.vehicleModel = null;
                    this.profileInfo.vehiclePurchaseYear = null;
                    this.getVehicleBrandsModels();
                  }
                "
                value-key="BrandName"
                :default-index="vehicleBrandIndex"
              />
            </van-popup>
          </div>

          <div
            class="line-box"
            v-if="profileInfo.vehicleBrand && profileInfo.vehicleBrand !== 1"
          >
            <div class="line-left">{{ $t("module.account.title44") }}</div>
            <div class="input-box" @click="vehicleModelPicker = true">
              <div class="title" v-if="!profileInfo.vehicleModel">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{
                  profileInfo.vehicleModel
                    | labelName(VehicleBrandsModels, "ModelName")
                }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup v-model="vehicleModelPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="VehicleBrandsModels"
                @cancel="vehicleModelPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.vehicleModel = e.ID;
                    this.vehicleModelPicker = false;
                  }
                "
                value-key="ModelName"
                :default-index="vehicleModelIndex"
              />
            </van-popup>
          </div>

          <div
            class="line-box"
            v-if="profileInfo.vehicleBrand && profileInfo.vehicleBrand !== 1"
          >
            <div class="line-left">{{ $t("module.account.title45") }}</div>
            <div class="input-box" @click="vehiclePurchaseYearPicker = true">
              <div class="title" v-if="!profileInfo.vehiclePurchaseYear">
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2">
                {{ profileInfo.vehiclePurchaseYear }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup
              v-model="vehiclePurchaseYearPicker"
              round
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="YearList"
                @cancel="vehiclePurchaseYearPicker = false"
                @confirm="
                  (e) => {
                    this.profileInfo.vehiclePurchaseYear = e.year;
                    this.vehiclePurchaseYearPicker = false;
                  }
                "
                value-key="year"
                :default-index="vehiclePurchaseYearIndex"
              />
            </van-popup>
          </div>

          <div class="line-box" v-if="Diseases1.length !== 0">
            <div class="line-left">{{ $t("module.account.title46") }}</div>
            <div class="input-box" @click="personalDiseasePicker = true">
              <div
                class="title"
                v-if="
                  !profileInfo.personalDisease ||
                  profileInfo.personalDisease.length === 0
                "
              >
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2 title2te">
                {{ profileInfo.personalDisease | labelName2(Diseases1) }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup
              v-model="personalDiseasePicker"
              round
              position="bottom"
              :style="{ height: '70%' }"
            >
              <div class="stry-top">
                <span
                  @click="personalDiseasePicker = false"
                  class="stry-quxiao"
                  >{{ $t("module.account.title59") }}</span
                >
                <span @click="personalDiseasePicker = false">{{
                  $t("module.account.title60")
                }}</span>
              </div>
              <div class="stry-bottom">
                <van-checkbox-group v-model="profileInfo.personalDisease">
                  <van-cell v-for="item in Diseases1" :key="item.ID" clickable>
                    <template #title>{{ item.DiseaseName }}</template>
                    <template #right-icon>
                      <van-checkbox
                        :name="item.ID"
                        :disabled="isPersonalDisease(item.ID)"
                      />
                    </template>
                  </van-cell>
                </van-checkbox-group>
              </div>
            </van-popup>
          </div>

          <div class="line-box" v-if="Diseases.length !== 0">
            <div class="line-left">{{ $t("module.account.title47") }}</div>
            <div class="input-box" @click="familyDiseasePicker = true">
              <div
                class="title"
                v-if="
                  !profileInfo.familyDisease ||
                  profileInfo.familyDisease.length === 0
                "
              >
                {{ $t("module.account.title33") }}
              </div>
              <div v-else class="title2 title2te">
                {{ profileInfo.familyDisease | labelName2(Diseases) }}
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
            <van-popup
              v-model="familyDiseasePicker"
              round
              position="bottom"
              :style="{ height: '70%' }"
            >
              <div class="stry-top">
                <span
                  @click="familyDiseasePicker = false"
                  class="stry-quxiao"
                  >{{ $t("module.account.title59") }}</span
                >
                <span @click="familyDiseasePicker = false">{{
                  $t("module.account.title60")
                }}</span>
              </div>
              <div class="stry-bottom">
                <van-checkbox-group v-model="profileInfo.familyDisease">
                  <van-cell v-for="item in Diseases" :key="item.ID" clickable>
                    <template #title>{{ item.DiseaseName }}</template>
                    <template #right-icon>
                      <van-checkbox
                        :name="item.ID"
                        :disabled="isPersonalDisease(item.ID)"
                      />
                    </template>
                  </van-cell>
                </van-checkbox-group>
              </div>
            </van-popup>
          </div>
        </div>
        <div class="moble-account">
          <div class="title-box">
            <span></span>{{ $t("module.account.title5") }}
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title21") }}</div>
            <div class="input-box">
              <div class="title">{{ userInfo.mobile }}</div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
          </div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title23") }}</div>
            <div class="input-box" @click="dialogVisible3 = true">
              <div class="title">{{ $t("module.account.title20") }}</div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title48") }}</div>
            <div class="input-box" v-if="alipay">
              <div class="title">
                <div v-if="alipay">
                  {{ alipayName }} {{ alipay | phoneFrom }}
                </div>
                <div v-else>{{ $t("module.account.title49") }}</div>
              </div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>

            <div class="input-box" @click="changeAlipay" v-else>
              <div class="title">{{ $t("module.account.title49") }}</div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
          </div>
        </div>
        <div class="moble-account">
          <div class="title-box">
            <span></span>{{ $t("module.account.title62") }}
          </div>

          <div class="line-box">
            <div class="line-left">{{ $t("module.account.title25") }}</div>
            <div class="input-box">
              <div class="title">{{ $t("module.account.title26") }}</div>
              <img src="@/assets/image/module/arrow-right.png" />
            </div>
          </div>
        </div>
        <button
          :class="`${flagpc ? 'flagpc moble-save' : 'moble-save'}`"
          @click="setProfile2"
        >
          {{ $t("module.account.title17") }}
        </button>
      </div>
    </div>
    <el-dialog
      :title="$t('module.account.title54')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <ModifyAvatar @getUerInfo="getUerInfo"></ModifyAvatar>
    </el-dialog>

    <el-dialog
      :title="$t('module.account.title48')"
      :visible.sync="dialogVisible2"
      :before-close="handleClose2"
    >
      <div class="dialog-herder">
        <div class="input-box">
          <div class="title">
            {{ $t("module.account.title6") }}
          </div>
          <el-input
            v-model="params1.name"
            :placeholder="$t('module.account.title6')"
          ></el-input>
        </div>

        <div class="input-box">
          <div class="title">{{ $t("module.account.title48") }}</div>
          <el-input
            v-model="params1.alipay"
            :placeholder="$t('module.account.title6')"
          ></el-input>
        </div>
      </div>

      <div class="dialog-footer">
        <div class="left">{{ $t("module.account.title61") }}</div>
        <div class="right">
          <div class="cancel" @click="handleClose2">
            {{ $t("module.account.title59") }}
          </div>
          <div class="submit" @click="setAlipay">
            {{ $t("module.account.title60") }}
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('module.account.title55')"
      :visible.sync="dialogVisible3"
      :before-close="handleClose3"
    >
      <div class="dialog-herder">
        <div class="input-box">
          <div class="title">{{ $t("module.account.title56") }}</div>
          <el-input
            v-model="oldPassword"
            type="password"
            :placeholder="$t('module.account.title32')"
          ></el-input>
        </div>
        <div class="input-box">
          <div class="title">{{ $t("module.account.title57") }}</div>
          <el-input
            v-model="newPassword"
            type="password"
            :placeholder="$t('module.account.title32')"
          ></el-input>
        </div>
        <div class="input-box">
          <div class="title">{{ $t("module.account.title58") }}</div>
          <el-input
            v-model="confirmPassword"
            type="password"
            :placeholder="$t('module.account.title32')"
          ></el-input>
        </div>
      </div>

      <div class="dialog-footer">
        <div class="left"></div>
        <div class="right">
          <div class="cancel" @click="handleClose3">
            {{ $t("module.account.title59") }}
          </div>
          <div class="submit" @click="changePassword">
            {{ $t("module.account.title60") }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import ModifyAvatar from "@/components/modifyAvatar";
import { generateYearList, calculateFillPercentage } from "@/utils/replace";
import {
  getAccount,
  uploadAttachment,
  getProfile,
  getProvinces,
  getCities,
  getDistricts,
  setProfile,
  setChangePassword,
  getAlipay,
  setAlipay,
  getMaritalStatus,
  getEducations,
  getWorkingStatus,
  getIncomes,
  getPositions,
  getVehicleBrands,
  getVehicleBrandsModels,
  getDiseases,
} from "@/api/user";
export default {
  filters: {
    leablDateFrom(id, data) {
      const item = data.find((item) => {
        return item.value === id;
      });
      return item ? item.label : "";
    },
    nameFrom(id, data) {
      let name = "";
      if (data) {
        const item = data.find((item) => {
          return item.id === id;
        });
        name = item.name;
      }
      return name ? name : "";
    },

    labelName(id, data, name) {
      const item = data.find((item) => {
        return item.ID === id;
      });
      return item ? item[name] : "";
    },

    labelName2(list1, data) {
      let name = "";

      for (let i = 0; i <= list1.length - 1; i++) {
        const value = data.find((cItem) => {
          return cItem.ID == list1[i];
        });
        name = name + "," + value.DiseaseName;
      }

      // const value = data.find((cItem) => {
      //   return cItem.ID == item;
      // });
      // name = value.DiseaseName + ",";

      return name ? name.slice(1) : "";
    },

    phoneFrom(phone) {
      return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  data() {
    return {
      value: null,
      menuTop: 86,
      activeName: "1",
      isName: false,
      userInfo: {},
      profileInfo: {
        id: null,
        name: null,
        gender: null,
        birthday: null,
        provinceId: null,
        cityId: null,
        districtId: null,
        maritalStatus: null,
        educationId: null,
        occupationStatus: null,
        personalIncome: null,
        familyIncome: null,
        positionId: null,
        hasChildren: true,
        childGender: null,
        birthYearOfYoungChild: null,
        vehicleBrand: null,
        vehicleModel: null,
        vehiclePurchaseYear: null,
        personalDisease: [],
        familyDisease: [],
      },
      option1: [
        {
          value: 1,
          label: this.$t("module.account.title63"),
        },
        {
          value: 2,
          label: this.$t("module.account.title64"),
        },
      ],

      province: null,
      cities: null,
      districts: null,

      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,

      genderPicker: false,
      birthdayPicker: false,

      birthdayIndex: null,
      birthday: null,
      minDate: new Date("1900-01-01"),
      maxDate: new Date(),
      provincePicker: false,
      citiesPicker: false,
      districtsPicker: false,
      maritalStatusPicker: false,
      educationsPicker: false,
      OccupationStatusPicker: false,
      personalIncomePicker: false,
      familyIncomePicker: false,
      positionIdPicker: false,
      hasChildrenPicker: false,
      childGenderPicker: false,
      birthYearOfYoungChildPicker: false,
      vehicleBrandPicker: false,
      vehicleModelPicker: false,
      vehiclePurchaseYearPicker: false,
      personalDiseasePicker: false,
      familyDiseasePicker: false,

      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      isTrue: true,

      alipay: null,
      alipayName: null,
      params1: {
        id: null,
        name: null,
        alipay: null,
        idCard: null,
        isDefault: true,
      },

      MaritalStatus: [],
      Educations: [],
      OccupationStatus: [],
      Incomes: [],
      Positions: [],
      VehicleBrands: [],
      VehicleBrandsModels: [],
      Diseases: [],
      Diseases1: [],
      YearList: generateYearList(),
      options: [
        { ID: true, label: this.$t("module.account.title65") },
        { ID: false, label: this.$t("module.account.title66") },
      ],
      options1: [
        { ID: 1, label: this.$t("module.account.title63") },
        { ID: 2, label: this.$t("module.account.title64") },
      ],

      flagpc: false,

      percentage: 0,

      selectedOptions: [],
      cascaderProps: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        value: "id",
        label: "name",
      },
      cascaderKey: 0,
    };
  },
  computed: {
    genderIndex() {
      let index = 0;
      if (this.profileInfo.gender) {
        index = this.profileInfo.gender - 1;
      }
      return index;
    },

    provinceIndex() {
      let index = 0;
      if (this.profileInfo.provinceId && this.province) {
        let newIndex = this.province.findIndex((item) => {
          return item.id === this.profileInfo.provinceId;
        });
        index = newIndex;
        console.log("省份", index);
      }
      return index;
    },

    citiesIndex() {
      let index = 0;
      if (this.profileInfo.cityId && this.cities) {
        let newIndex = this.cities.findIndex((item) => {
          return item.id === this.profileInfo.cityId;
        });
        index = newIndex;
      }
      return index;
    },
    districtsIndex() {
      let index = 0;
      if (this.profileInfo.districtId && this.districts) {
        let newIndex = this.districts.findIndex((item) => {
          return item.id === this.profileInfo.districtId;
        });
        index = newIndex;
      }
      return index;
    },

    MaritalIndex() {
      let index = 0;
      if (this.profileInfo.maritalStatus && this.MaritalStatus) {
        let newIndex = this.MaritalStatus.findIndex((item) => {
          return item.ID === this.profileInfo.maritalStatus;
        });
        index = newIndex;
      }
      return index;
    },

    EducationIndex() {
      let index = 0;
      if (this.profileInfo.educationId && this.Educations) {
        let newIndex = this.Educations.findIndex((item) => {
          return item.ID === this.profileInfo.educationId;
        });
        index = newIndex;
      }
      return index;
    },

    occupationStatusIndex() {
      let index = 0;
      if (this.profileInfo.occupationStatus && this.OccupationStatus) {
        let newIndex = this.OccupationStatus.findIndex((item) => {
          return item.ID === this.profileInfo.occupationStatus;
        });
        index = newIndex;
      }
      return index;
    },

    personalIncomeIndex() {
      let index = 0;
      if (this.profileInfo.personalIncome && this.Incomes) {
        let newIndex = this.Incomes.findIndex((item) => {
          return item.ID === this.profileInfo.personalIncome;
        });
        index = newIndex;
      }
      return index;
    },

    familyIncomeIndex() {
      let index = 0;
      if (this.profileInfo.familyIncome && this.Incomes) {
        let newIndex = this.Incomes.findIndex((item) => {
          return item.ID === this.profileInfo.familyIncome;
        });
        index = newIndex;
      }
      return index;
    },
    provinceIdIndex() {
      let index = 0;
      if (this.profileInfo.positionId && this.Positions) {
        let newIndex = this.Positions.findIndex((item) => {
          return item.ID === this.profileInfo.positionId;
        });
        index = newIndex;
      }
      return index;
    },

    hasChildrenIndex() {
      let index = 0;
      if (this.profileInfo.hasChildren && this.options) {
        let newIndex = this.options.findIndex((item) => {
          return item.ID === this.profileInfo.hasChildren;
        });
        index = newIndex;
      }
      return index;
    },
    childGenderIndex() {
      let index = 0;
      if (this.profileInfo.childGender && this.options1) {
        let newIndex = this.options1.findIndex((item) => {
          return item.ID === this.profileInfo.childGender;
        });
        index = newIndex;
      }
      return index;
    },

    birthYearOfYoungChildIndex() {
      let index = 0;
      if (this.profileInfo.birthYearOfYoungChild && this.YearList) {
        let newIndex = this.YearList.findIndex((item) => {
          return item.id === this.profileInfo.birthYearOfYoungChild;
        });
        index = newIndex;
      }
      return index;
    },

    vehicleBrandIndex() {
      let index = 0;
      if (this.profileInfo.vehicleBrand && this.VehicleBrands) {
        let newIndex = this.VehicleBrands.findIndex((item) => {
          return item.ID === this.profileInfo.vehicleBrand;
        });
        index = newIndex;
      }
      return index;
    },

    vehicleModelIndex() {
      let index = 0;
      if (this.profileInfo.vehicleModel && this.VehicleBrandsModels) {
        let newIndex = this.VehicleBrandsModels.findIndex((item) => {
          return item.ID === this.profileInfo.vehicleModel;
        });
        index = newIndex;
      }
      return index;
    },

    vehiclePurchaseYearIndex() {
      let index = 0;
      if (this.profileInfo.vehiclePurchaseYear && this.YearList) {
        let newIndex = this.YearList.findIndex((item) => {
          return item.id === this.profileInfo.vehiclePurchaseYear;
        });
        index = newIndex;
      }
      return index;
    },
  },
  components: { Navigation, ModifyAvatar },
  methods: {
    lazyLoad(node, resolve) {
      const { level, value } = node;

      if (level === 0) {
        getProvinces()
          .then((res) => {
            if (res.code === 200) {
              const nodes = res.data
                .filter((item) => item && item.id && item.name)
                .map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: false,
                }));
              resolve(nodes);
            } else {
              resolve([]);
            }
          })
          .catch(() => resolve([]));
      } else if (level === 1) {
        getCities({ id: value })
          .then((res) => {
            if (res.code === 200) {
              const nodes = Object.values(res.data)
                .filter((item) => item && item.id && item.name)
                .map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: false,
                }));
              resolve(nodes);
            } else {
              resolve([]);
            }
          })
          .catch(() => resolve([]));
      } else if (level === 2) {
        getDistricts({ id: value })
          .then((res) => {
            if (res.code === 200) {
              const nodes = res.data
                .filter((item) => item && item.id && item.name)
                .map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: true,
                }));
              resolve(nodes);
            } else {
              resolve([]);
            }
          })
          .catch(() => resolve([]));
      }
    },
    isPersonalDisease(ID) {
      let flag = false;
      if (this.profileInfo.personalDisease.length === 0) {
        flag = false;
      }

      if (this.profileInfo.personalDisease.length === 1) {
        if (this.profileInfo.personalDisease[0] == 34) {
          if (ID != 34) {
            flag = true;
          }
        } else {
          if (ID == 34) {
            flag = true;
          }
        }
      }

      if (this.profileInfo.personalDisease.length >= 2) {
        if (ID == 34) {
          flag = true;
        }
      }

      return flag;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },

    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },

    //上传头像
    uploadAttachment(file) {
      const data = file.file;
      var img = data.name.substring(data.name.lastIndexOf(".") + 1);
      const suffix = img === "jpg";
      const suffix2 = img === "png";
      const suffix3 = img === "jpeg";
      if (!suffix && !suffix2 && !suffix3) {
        this.$message.error(this.$t("只能上传jpg、png、jpeg三种类型文件"));
        return;
      }
      const formData = new FormData();
      formData.append("Files", data);
      uploadAttachment(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success("修改成功");
          getAccount().then((res) => {
            if (res.code === 200) {
              this.userInfo = res.data;
              localStorage.setItem("userInfo", JSON.stringify(res.data));
            }
          });
        }
      });
    },

    //获取基础信息
    async getProfile() {
      await getProfile().then((res) => {
        if (res.code) {
          this.profileInfo = {
            id: res.data.id,
            name: res.data.name,
            gender: res.data.gender || null,
            birthday: res.data.birthday,
            provinceId: res.data.provinceId || null,
            cityId: res.data.cityId || null,
            districtId: res.data.districtId || null,

            maritalStatus: res.data.maritalStatus || null,
            educationId: res.data.educationId || null,
            occupationStatus: res.data.occupationStatus || null,
            personalIncome: res.data.personalIncome || null,
            familyIncome: res.data.familyIncome || null,
            positionId: res.data.positionId || null,
            hasChildren: res.data.hasChildren,
            childGender: res.data.childGender || null,
            birthYearOfYoungChild: res.data.birthYearOfYoungChild
              ? res.data.birthYearOfYoungChild + ""
              : "",
            vehicleBrand: res.data.vehicleBrand || null,
            vehicleModel: res.data.vehicleModel || null,
            vehiclePurchaseYear: res.data.vehiclePurchaseYear
              ? res.data.vehiclePurchaseYear + ""
              : "",
            personalDisease: res.data.personalDisease || [],
            familyDisease: res.data.familyDisease || [],
          };

          if (res.data.provinceId && res.data.cityId && res.data.districtId) {
            this.selectedOptions.push(res.data.provinceId);
            this.selectedOptions.push(res.data.cityId);
            this.selectedOptions.push(res.data.districtId);
            this.initOptions();
          }

          if (!res.data.birthday) {
            this.birthdayIndex = new Date(this.profileInfo.birthday);
            this.birthday = new Date(this.profileInfo.birthday);
          } else {
            this.birthdayIndex = new Date();
            this.birthday = new Date();
          }

          if (res.data.name) {
            this.isName = true;
          }

          this.percentage = calculateFillPercentage(this.profileInfo);
        }
      });
    },

    async initOptions() {
      const [provinceId, cityId, districtId] = this.selectedOptions;

      // 1. 加载省份列表
      const provinceRes = await getProvinces();
      this.options = provinceRes.data.map((item) => ({
        id: item.id,
        name: item.name,
        leaf: false,
      }));

      console.log("12321", provinceRes);

      // 2. 加载当前省份下的城市列表
      if (provinceId) {
        const cityRes = await getCities({ id: provinceId });
        const cityNodes = Object.values(cityRes.data).map((item) => ({
          id: item.id,
          name: item.name,
          leaf: false,
        }));
        // 把城市挂到对应省份的 children 下
        const provinceNode = this.options.find((p) => p.id === provinceId);
        if (provinceNode) {
          provinceNode.children = cityNodes;
        }

        // 3. 加载当前城市下的区县列表
        if (cityId) {
          const districtRes = await getDistricts({ id: cityId });
          const districtNodes = Object.values(districtRes.data).map((item) => ({
            id: item.id,
            name: item.name,
            leaf: true,
          }));
          const cityNode = cityNodes.find((c) => c.id === cityId);
          if (cityNode) {
            cityNode.children = districtNodes;
          }
        }
      }

      this.cascaderKey++;
    },

    //获取省份
    async getProvinces() {
      await getProvinces().then((res) => {
        if (res.code === 200) {
          this.province = res.data;
        }
      });
    },

    handleChange() {
      console.log(this.selectedOptions);
    },

    changeProvinceId2(e) {
      this.profileInfo.provinceId = e.id;
      this.profileInfo.cityId = null;
      this.profileInfo.districtId = null;
      this.getCities();
      this.provincePicker = false;
    },

    //获取城市
    async getCities() {
      await getCities({
        id: this.profileInfo.provinceId,
      }).then((res) => {
        if (res.code === 200) {
          this.cities = res.data;
        }
      });
    },

    changeCityId2(e) {
      this.profileInfo.cityId = e.id;
      this.profileInfo.districtId = null;
      this.getDistricts();
      this.citiesPicker = false;
    },

    //获取区县
    async getDistricts() {
      await getDistricts({
        id: this.profileInfo.cityId,
      }).then((res) => {
        if (res.code === 200) {
          this.districts = res.data;
        }
      });
    },

    changeDistricts2(e) {
      this.profileInfo.districtId = e.id;
      this.districtsPicker = false;
    },

    //修改个人信息
    setProfile() {
      if (this.flagpc) {
        return;
      }
      this.flagpc = true;
      const profileInfo = JSON.parse(JSON.stringify(this.profileInfo));
      if (this.selectedOptions.length > 0) {
        profileInfo.provinceId = this.selectedOptions[0];
        profileInfo.cityId = this.selectedOptions[1];
        profileInfo.districtId = this.selectedOptions[2];
      }
      setProfile(profileInfo).then((res) => {
        console.log(res.code == 200);
        this.flagpc = false;
        if (res.code == 200) {
          this.$message.success("保存成功");
        }
      });
    },
    setProfile2() {
      if (this.flagpc) {
        return;
      }
      this.flagpc = true;
      setProfile(this.profileInfo).then((res) => {
        console.log(res.code == 200);
        this.flagpc = false;
        if (res.code == 200) {
          this.$message.success("保存成功");
          const profileInfo = JSON.parse(JSON.stringify(this.profileInfo));
          if (
            profileInfo.provinceId &&
            profileInfo.cityId &&
            profileInfo.districtId
          ) {
            this.selectedOptions=[]
            this.selectedOptions.push(profileInfo.provinceId);
            this.selectedOptions.push(profileInfo.cityId);
            this.selectedOptions.push(profileInfo.districtId);
            this.initOptions();
          }
        }
      });
    },

    //修改密码
    changePassword() {
      setChangePassword({
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("修改成功");
          this.$router.push("/login");
        }
      });
    },

    formatDate(date) {
      let d = new Date(date);
      let year = d.getFullYear();
      let month = ("0" + (d.getMonth() + 1)).slice(-2); // 月份是从0开始的
      let day = ("0" + d.getDate()).slice(-2);
      return year + "-" + month + "-" + day;
    },

    //日历选择
    birthdayConfirm(date) {
      this.profileInfo.birthday = this.formatDate(date);
      this.birthdayPicker = false;
      console.log("this.profileInfo.birthday", date);
    },

    birthdayConfirm2(date) {
      this.profileInfo.birthYearOfYoungChild = new Date(date).getFullYear();
      this.birthYearOfYoungChildPicker = false;
    },

    async getUerInfo() {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;

          this.$store.commit("changeUserInfo", this.userInfo);

          localStorage.setItem("userInfo", JSON.stringify(res.data));
          this.handleClose();
        }
      });
    },

    //获取支付宝信息
    async getAlipay() {
      await getAlipay().then((res) => {
        if (res.code === 200) {
          this.alipay = res.data.alipay;
          this.alipayName = res.data.name;
        }
      });
    },

    //绑定支付宝弹窗
    changeAlipay() {
      this.dialogVisible2 = true;
      this.params1 = {
        id: this.profileInfo.id,
        name: this.profileInfo.name,
        alipay: null,
        idCard: null,
        isDefault: true,
      };
    },

    //修改支付宝信息
    setAlipay() {
      setAlipay(this.params1).then(async (res) => {
        if (res.code === 200) {
          this.$message.success("绑定成功");
          this.handleClose2();
          await this.getAlipay();
          await this.getProfile();
        }
      });
    },

    //婚姻状况
    async getMaritalStatus() {
      await getMaritalStatus().then(async (res) => {
        if (res.code === 200) {
          this.MaritalStatus = res.data;
        }
      });
    },
    //学历
    async getEducations() {
      await getEducations().then(async (res) => {
        if (res.code === 200) {
          this.Educations = res.data;
        }
      });
    },

    //工作状态
    async getWorkingStatus() {
      await getWorkingStatus().then(async (res) => {
        if (res.code === 200) {
          this.OccupationStatus = res.data;
        }
      });
    },

    //收入
    async getIncomes() {
      await getIncomes().then(async (res) => {
        if (res.code === 200) {
          this.Incomes = res.data;
        }
      });
    },

    //职位
    async getPositions() {
      await getPositions().then(async (res) => {
        if (res.code === 200) {
          this.Positions = res.data;
        }
      });
    },
    //汽车品牌
    async getVehicleBrands() {
      await getVehicleBrands().then(async (res) => {
        if (res.code === 200) {
          this.VehicleBrands = res.data;
        }
      });
    },

    //汽车型号
    async getVehicleBrandsModels() {
      this.profileInfo.vehicleModel = null;
      this.profileInfo.vehiclePurchaseYear = null;
      if (this.profileInfo.vehicleBrand) {
        await getVehicleBrandsModels({
          id: this.profileInfo.vehicleBrand,
        }).then(async (res) => {
          if (res.code === 200) {
            this.VehicleBrandsModels = res.data || [];
          }
        });
      } else {
        this.VehicleBrandsModels = [];
      }
    },

    //患病
    async getDiseases() {
      await getDiseases().then(async (res) => {
        if (res.code === 200) {
          this.Diseases = res.data;
          this.changeGender();
        }
      });
    },

    changeGender() {
      console.log("改变性别", this.profileInfo.gender);
      this.Diseases1 = JSON.parse(JSON.stringify(this.Diseases));
      if (this.profileInfo.gender === 1) {
        const index1 = this.Diseases1.findIndex((item) => {
          return item.ID === 28;
        });
        console.log("index1", index1);
        this.Diseases1.splice(index1, 1);
      }

      if (this.profileInfo.gender === 2) {
        const index2 = this.Diseases1.findIndex((item) => {
          return item.ID === 18;
        });
        this.Diseases1.splice(index2, 1);
        const index3 = this.Diseases1.findIndex((item) => {
          return item.ID === 21;
        });
        this.Diseases1.splice(index3, 1);
      }
    },

    changePersonalDisease() {
      const data = this.profileInfo.personalDisease;
      if (data.length === 2 && data[0] === 34) {
        this.profileInfo.personalDisease.shift();
      } else if (data[data.length - 1] === 34) {
        this.profileInfo.personalDisease = [34];
      }
    },

    changeFamilyDisease() {
      const data = this.profileInfo.familyDisease;
      if (data.length === 2 && data[0] === 34) {
        this.profileInfo.familyDisease.shift();
      } else if (data[data.length - 1] === 34) {
        this.profileInfo.familyDisease = [34];
      }
    },
  },
  async created() {
    window.addEventListener("scroll", this.listenScroll);
    await this.getProfile();
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }

    await this.getProvinces();
    await this.getCities();
    await this.getDistricts();
    await this.getAlipay();

    await this.getMaritalStatus();
    await this.getEducations();
    await this.getWorkingStatus();
    await this.getIncomes();
    await this.getPositions();
    await this.getVehicleBrands();
    await this.getDiseases();
    if (this.profileInfo.vehicleBrand) {
      await getVehicleBrandsModels({
        id: this.profileInfo.vehicleBrand,
      }).then(async (res) => {
        if (res.code === 200) {
          this.VehicleBrandsModels = res.data || [];
        }
      });
    }
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>
<style scoped>
.flagpc {
  opacity: 0.7;
}
.stry-top {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  align-items: center;
  height: 40px;
}
.stry-bottom {
  height: calc(100% - 40px);
  overflow-y: auto;
}
.stry-quxiao {
  color: #969799;
}
.my-info >>> .el-progress__text {
  font-size: 16px;
  color: #474f66;
}
.my-info >>> .el-progress-bar__inner {
  background: linear-gradient(98deg, #ba95ff 0%, #8948ff 100%);
}
.tabs-box >>> .el-tabs .el-tabs__item {
  height: 66px;
  line-height: 66px;
  padding: 0 31px;
  font-size: 16px;
}

.tabs-box >>> .el-tabs .el-tabs__item:hover {
  color: #8948ff;
}
.tabs-box >>> .el-tabs .el-tabs__active-bar {
  color: #8948ff;
  background-color: #8948ff;
}

.tabs-box >>> .el-tabs .is-active {
  color: #8948ff;
  font-weight: bolder;
}
.tabs-box >>> .el-tabs .el-tabs__nav-wrap::after {
  background-color: #f0f5ff;
  height: 1px;
}
.input-box >>> .el-input__inner {
  border-radius: 4px !important;
}
.input-box >>> .el-input__inner:focus {
  border-color: #8948ff !important;
}
.input-box >>> .el-input__inner:hover {
  border-color: #8948ff !important;
}
</style>
<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
    //个人信息
    .my-info {
      padding: 30px 30px 42px 30px;
      width: 100%;
      background: #ffffff;
      border-radius: 4px;
      box-sizing: border-box;
      .title {
        font-size: 16px;
        color: #474f66;
        font-weight: bolder;
      }
      .info-box {
        display: flex;
        align-items: center;
        margin-top: 50px;
        .head-box {
          position: relative;
          width: 68px;
          height: 68px;
          border-radius: 34px;
          .head {
            width: 68px;
            height: 68px;
            border-radius: 34px;
            cursor: pointer;
          }
          .picture-box {
            position: absolute;
            width: 68px;
            height: 68px;
            border-radius: 34px;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.4);
            color: #ddd;
            font-size: 20px;
          }
        }

        .name-box {
          display: flex;
          flex-direction: column;
          margin-left: 15px;
          .name {
            font-size: 16px;
            color: #474f66;
            margin-bottom: 12px;
          }
          .content {
            display: flex;
            .content-title {
              font-size: 14px;
              color: #474f66;
              margin-right: 28px;
            }
            .el-progress {
              width: 178px;
            }
            .tips {
              font-size: 14px;
              color: #fd8543;
              margin-left: 40px;
            }
          }
        }
      }
    }
    //信息管理
    .tabs-box {
      width: 100%;
      min-height: 698px;
      background: #ffffff;
      border-radius: 4px 44;
      box-sizing: border-box;
      margin-top: 16px;
      margin-bottom: 41px;
      .info-boxs:first-child {
        margin-top: 20px;
      }
      .info-boxs {
        display: flex;
        flex-direction: column;
        .line-box {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 0 20px;
          margin-bottom: 41px;
          .input-box {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .title {
              flex-shrink: 0;
              font-size: 14px;
              color: #474f66;
              margin-right: 20px;
              width: 125px;
              text-align: right;
              span {
                font-size: 16px;
                color: #f72600;
                margin-right: 3px;
              }
            }
            .el-input {
              width: 240px;
            }
            .el-select {
              width: 240px;
            }
            .el-cascader {
              width: 240px;
            }
            button {
              padding: 0;
              border: none;
              padding: 0 32px;
              height: 34px;
              line-height: 34px;
              background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
              box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
              border-radius: 17px;
              color: #fff;
              font-size: 14px;
              cursor: pointer;
            }
          }
        }
      }

      .account-boxs {
        width: 100%;
        padding: 0 25px;
        box-sizing: border-box;
        .account-box {
          width: 100%;
          border-bottom: 1px solid #f0f5ff;
          .herder-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            font-weight: bolder;
            margin-top: 30px;
            .herder-left {
              display: flex;
              align-items: center;
              color: #474f66;
              .herder-title {
                width: 100px;
                text-align: right;

                margin-right: 45px;
              }
            }
            .herder-right {
              color: #8948ff;
              margin-right: 20px;
              cursor: pointer;
            }
          }
          .tips {
            font-size: 14px;
            color: #adadad;
            margin-left: 145px;
            margin-top: 30px;
            margin-bottom: 22px;
          }
        }
        .account-box:last-child {
          border: none;
          margin-bottom: 58px;
        }
      }
    }

    .moble-name {
      display: none;
      font-size: 16px;
      color: #232323;
      font-weight: bolder;
    }
    .moble-info {
      display: none;
      width: 100%;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      padding: 16px 11px;
      margin-top: 15px;
      box-sizing: border-box;

      .info-box {
        display: flex;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 20px;
        .head-box {
          position: relative;
          width: 68px;
          height: 68px;
          border-radius: 34px;
          .head {
            width: 68px;
            height: 68px;
            border-radius: 34px;
            cursor: pointer;
          }
          .picture-box {
            position: absolute;
            width: 68px;
            height: 68px;
            border-radius: 34px;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.4);
            color: #ddd;
            font-size: 20px;
          }
        }
        .name-box {
          display: flex;
          flex-direction: column;
          margin-left: 15px;
          .name {
            font-size: 16px;
            color: #474f66;
            margin-bottom: 12px;
          }
          .content {
            display: flex;
            .content-title {
              font-size: 14px;
              color: #474f66;
              margin-right: 28px;
            }
            .el-progress {
              width: 178px;
            }
          }
          .tips {
            font-size: 12px;
            color: #fd8543;
            margin-top: 10px;
          }
        }
      }
      .title-box {
        font-size: 16px;
        color: #232323;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        span {
          height: 12px;
          width: 2px;
          background-color: #8846ff;
          margin-right: 9px;
        }
      }
      .line-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        .line-left {
          font-size: 14px;
          color: #232323;
        }
        .input-box {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
          cursor: pointer;
          input {
            text-align: right;
            border: none;
            color: #232323;
          }
          .title2 {
            color: #232323;

            text-align: right;
          }
          .title2te {
            /* 1. 必须指定宽度（固定值或百分比） */
            width: 150px;
            /* 2. 强制文本不换行 */
            white-space: nowrap;
            /* 3. 隐藏超出容器的内容 */
            overflow: hidden;
            /* 4. 溢出时显示省略号 */
            text-overflow: ellipsis;
          }
          img {
            width: 14px;
            height: 14px;
            margin-left: 4px;
          }
        }
      }
    }
    .moble-account {
      display: none;
      width: 100%;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      padding: 16px 11px;
      margin-top: 20px;
      box-sizing: border-box;
      .title-box {
        font-size: 16px;
        color: #232323;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        span {
          height: 12px;
          width: 2px;
          background-color: #8846ff;
          margin-right: 9px;
        }
      }
      .line-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        .line-left {
          font-size: 14px;
          color: #232323;
        }
        .input-box {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
          cursor: pointer;
          img {
            width: 14px;
            height: 14px;
            margin-left: 4px;
          }
        }
      }
    }
    .moble-save {
      display: none;
      width: calc(100% - 86px);
      padding: 0;
      border: none;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      height: 36px;
      background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
      border-radius: 18px 18px 18px 18px;
      color: #fff;
      margin-top: 30px;
      margin-bottom: 41px;
      cursor: pointer;
    }
  }
}
.dialog-herder {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  .input-box {
    margin-top: 10px;
    .title {
      margin-bottom: 10px;
      color: #474f66;
      font-size: 14px;
    }
  }
}
.dialog-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 20px 20px;
  display: flex;
  justify-content: space-between;
  .left {
    color: #ff2e26;
    font-size: 12px;
    font-weight: bolder;
  }
  .right {
    display: flex;
  }
  .cancel {
    padding: 0 24px;
    height: 32px;
    line-height: 32px;
    background: #f8f8f8;
    border: 1px solid #eee;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
  }
  .submit {
    padding: 0 24px;
    height: 32px;
    line-height: 32px;
    background: #8948ff;
    border: 1px solid #8948ff;
    border-radius: 4px 4px 4px 4px;
    color: #fff;
    margin-left: 21px;
    cursor: pointer;
  }
}
</style>

<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .tabs-box {
        .info-boxs {
          .line-box {
            .input-right {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1100px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .tabs-box {
        .info-boxs {
          .line-box {
            .input-box {
              .el-input {
                width: 180px;
              }
              .el-select {
                width: 180px;
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
      .sign-box {
        display: none;
      }
      .sign-box-mobie {
        display: flex;
      }
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      .my-info {
        display: none;
      }
      .tabs-box {
        display: none;
      }
      .moble-name {
        display: block;
      }
      .moble-info {
        display: block;
      }
      .moble-account {
        display: block;
      }
      .moble-save {
        display: block;
      }
    }
  }
}
</style>

<style scoped>
@media only screen and (max-width: 750px) {
  .el-dialog__wrapper >>> .el-dialog {
    width: 90% !important;
  }
}
</style>